import { DocCategoryFormData, DocCategoryListApiResponse, DocCategoryGetApiResponse } from "../context/DocumentCategoryContext/constants";
import { axiosInstance } from "../utils/axiosInstance";

const ENDPOINTS = {
	ADD: "/cms/add-doc-category",
	UPDATE: "/cms/update-doc-category",
	REMOVE: "/cms/remove-doc-category",
	LIST: "/cms/get-doc-categories",
	GET: "/cms/get-doc-category-details",
};

export class DocCategoryService {
	static async addDocCategory(docCategoryData: DocCategoryFormData) {
		const formData = new FormData();

		if (docCategoryData.categoryNo !== undefined && docCategoryData.categoryNo !== null) {
			formData.append("categoryNo", docCategoryData.categoryNo.toString());
		}

		formData.append("categoryName", docCategoryData.categoryName);

		const response = await axiosInstance.post(`${ ENDPOINTS.ADD }`, formData);
		return response.data;
	}

	static async getDocCategoryList(): Promise<DocCategoryListApiResponse> {
		const response = await axiosInstance.get(ENDPOINTS.LIST);
		return response.data;	
	}

	static async getDocCategoryDetails(id: string): Promise<DocCategoryGetApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.GET}?categoryId=${id}`);
		return response.data;
	}

	static async updateDocCategory(docCategoryData: DocCategoryFormData) {
		const formData = new FormData();

		if (docCategoryData.categoryId !== undefined && docCategoryData.categoryId !== null) {
			formData.append("categoryId", docCategoryData.categoryId.toString());
		}

		if (docCategoryData.categoryNo !== undefined && docCategoryData.categoryNo !== null) {
			formData.append("categoryNo", docCategoryData.categoryNo.toString());
		}

		if (docCategoryData.categoryName?.trim()) {
			formData.append("categoryName", docCategoryData.categoryName);
		}

		const response = await axiosInstance.patch(`${ENDPOINTS.UPDATE}`, formData);
		return response.data;
	}

	static async removeDocCategory(id: string) {
		const response = await axiosInstance.delete(`${ENDPOINTS.REMOVE}?categoryId=${id}`);
		return response.data;
	}
}